import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton, getTheme } from "office-ui-fabric-react";
import * as React from "react";
import { LocalizeContextProps, withLocalize } from "react-localize-redux";
import "./MessageDialogComponent.less";

export interface MessageDialogProps extends LocalizeContextProps {
    onConfirmButtonClicked: () => void;
    onDismiss: () => void;
    hidden: boolean;
    title: string;
    subText: string;
    theme?: string;
}

class MessageDialogComponent extends React.Component<MessageDialogProps, any> {
    render(): JSX.Element {
        const theme = getTheme();
        return (
            <Dialog
                hidden={this.props.hidden}
                onDismiss={this.props.onDismiss}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: this.props.title,
                    subText: this.props.subText,
                    styles: { title: { fontSize: 22 }, subText: { fontSize: 16 } },
                }}
                modalProps={{
                    titleAriaId: "1",
                    subtitleAriaId: "1",
                    isBlocking: false,
                    styles: {
                        main: { maxWidth: 450, backgroundColor: theme.semanticColors.bodyBackground },
                    },
                    isDarkOverlay: this.props.theme === "default" ? false : true,
                }}
            >
                <DialogFooter>
                    <PrimaryButton
                        id="confirmButton"
                        onClick={this.props.onConfirmButtonClicked}
                        text={this.props.translate("APP.SETTINGS.YES") as string}
                        className={`resetPrimaryButton`}
                        data-theme={this.props.theme}
                    />
                    <DefaultButton
                        id="cancelButton"
                        onClick={this.props.onDismiss}
                        text={this.props.translate("APP.SETTINGS.NO") as string}
                        className="resetDefaultButton"
                    />
                </DialogFooter>
            </Dialog>
        );
    }
}

export default withLocalize(MessageDialogComponent);
